import { AlertCircle } from 'lucide-react';

import { Alert } from '../Alert/Alert';
import { AlertDescription } from '../Alert/Alert.Description';
import { AlertTitle } from '../Alert/Alert.Title';

type Props = {
  children: React.ReactNode;
};

export const ErrorAlert = ({ children }: Props) => {
  return (
    <div className={`mb-1 mt-3`}>
      <Alert variant={`destructive`} className={`w-full max-w-lg`}>
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Error</AlertTitle>
        <AlertDescription>{children}</AlertDescription>
      </Alert>
    </div>
  );
};
